<template>
	<div class="home">
		<div v-if="selectCity" @click="selectCity=!selectCity" class="Mask"></div>
		<Header :active="1"></Header>
		<div class="searchDiv">
			<div class="content">
				<div class="position">
					当前位置：
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item :to="{ path: '/' }">网站首页</el-breadcrumb-item>
						<el-breadcrumb-item>找工作</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="searchTo flex">
					<div @click="selectCity=!selectCity" class="address">
						<p>{{CityOn.result}}</p>
						<img
							:src="`https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/${selectCity?'top':'p9'}.png`">
					</div>
					<el-input v-model="search" placeholder="请输入您想查找的岗位或公司" clearable></el-input>
					<div @click="getList" class="searchButton">
						搜索
					</div>
				</div>
				<div v-if="selectCity" class="citys">
					<div class="hotCity">
						<div class="title">
							热门城市
						</div>
						<div class="list">
							<div @click="hotCityClick(true,index)" :class="{on:CityOn.City1==index&&CityOn.CityType}"
								v-for="(item,index) in hotCity" :key="index">{{item.cityName}}</div>
						</div>
					</div>
					<!-- <div class="regionList">
						<div v-for="(item,index) of region" :key="index" class="regionList-q flex">
							<div class="regionName">
								{{item.code}}
							</div>
							<div class="list">
								<div :class="{on:CityOn.City2.i==index&&CityOn.City2.j==index2&&!CityOn.CityType}"
									@click="hotCityClick(false,index,index2)" v-for="(item2,index2) in item.cityList"
									:key="index2">{{item2}}</div>
							</div>
						</div>
					</div> -->
					<div @click="toPage('./citys')" class="moduo">
						更多》
					</div>
				</div>
			</div>
		</div>
		<div v-loading="loading" class="screen">
			<div class="content">
				<div class="screen-list">
					<div class="name"> 工资 </div>
					<div class="list-div">
						<div @click="salaryClick(index)" :class="{'list-on':salaryListOn==index}"
							v-for="(item,index) in salaryList" :key="index">
							{{item.label}}{{(item.label!=='薪资不限'&&item.label!=='面议')?'元/每月':''}}
						</div>
					</div>
				</div>
				<div class="screen-list">
					<div class="name"> 职位 </div>
					<div class="list-div">
						<div @click="positionClick(index)" :class="{'list-on':positionListOn==index}"
							v-for="(item,index) in positionEnumerationList" :key="index">
							{{item.label}}
						</div>
					</div>
				</div>
				<div class="screen-list">
					<div class="name"> 福利 </div>
					<div class="list-div">
						<div @click="checkedWelfare=[],checkbox()" :class="{'list-on':checkedWelfare.length==0}" class="WelfareNo">
							不限</div>
						<el-checkbox-group @change="checkbox()" v-model="checkedWelfare">
							<el-checkbox v-for="(Welfare,index) in welfareList" :label="Welfare" :key="index">
								{{Welfare}}
							</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
			</div>
		</div>
		<div v-loading="loading" class="position-list">
			<div v-if="positionList.length>0" class="content">
				<div @click="toPageTwo(item.id)" v-for="(item,index) in positionList" :key="index" class="list">
					<div class="logo">
						<img :src="handelHttps(item.customerLogo)">
					</div>
					<div class="right">
						<div class="title flex">
							<div class="name flex">
								{{item.employName}}
								<img v-if="item.employProcess == 'PUBLISHED' && item.urgency == 'URGENT'"
									src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/P5.png">
								<img v-if="item.employProcess == 'PUBLISHED' && item.hotspot == 'START'"
									src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/P6.png">
							</div>
							<div class="money">
								{{item.startSalary|handlePay(item.endSalary)}}/月
							</div>
						</div>
						<div class="treatment">
							学历要求：
							<template v-for="(i,indexs) in educationList">
								<span :key="indexs" class="line" v-if="item.education === i.value">{{i.text}}</span>
							</template>

							工作年限：
							<template v-for="(i,indexs) in workingYearList">
								<span :key="indexs+'t'" class="line"
									v-if="item.workingYears === i.value">{{i.text}}</span>
							</template>
							<!-- 年龄要求：18~45周岁 -->
						</div>
						<div class="treatment">
							工作地点：[{{item.workAddress.province}}-{{item.workAddress.city}}-{{item.workAddress.county}}]
						</div>
						<div class="treatment nanse">
							职位福利：<span v-for="(item2,i) in item.welfare" :key="i">{{item2}}</span>
						</div>
						<div class="reward flex">
							<div class="reward-list flex">
								<div v-if="item.commission != 0&&(item.hiredCustomerId!==item.customerId||item.interior== 0)"
									class="reward-one">
									推荐奖励￥{{item.commission / 100| keepOne}}
								</div>
								<div v-if="item.refund != 0" class="reward-two">
									入职补贴￥{{item.refund / 100 | keepOne}}
								</div>
								<div v-if="item.bounty != 0" class="reward-three">
									赏金￥{{item.bounty / 100 | keepOne}}
								</div>
							</div>
							<div @click.stop="interview(item.id,index)" class="reward-anniu">
								申请面试
							</div>
						</div>
					</div>
				</div>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="10"
					layout="total, sizes, prev, pager, next, jumper" :total="TotalNumber" background>
				</el-pagination>
			</div>
			<div v-else class="content">
				<div class="NotYet">
					<img src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/NotYet.png">
					暂无内容
				</div>
			</div>
		</div>
		<el-dialog title="申请面试" :visible.sync="centerDialogVisible" width="560px" center>
			<div v-if="positionList[0]" class="reweima">
				<div class="left">
					<div class="title">
						{{positionList[positionOn].employName}}
					</div>
					<div class="money">
						{{positionList[positionOn].startSalary|handlePay(positionList[positionOn].endSalary)}}/月
					</div>
					<div class="welfare">
						<div v-for="(i,indext) in positionList[positionOn].welfare" :key="indext">{{i}}</div>
					</div>
					<div class="Company">
						{{positionList[positionOn].company}}
					</div>
					<div class="address">
						<img src="https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/adress.png">
						{{positionList[positionOn].workAddress.addressDetail||'暂无'}}
					</div>
				</div>
				<div v-loading="qrCodeLoading" class="right">
					<img :src="qrCode" alt="小程序二维码">
					<div>手机微信扫一扫 申请面试</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Header from '../components/subHead.vue'
	import area from '../assets/area.json'
	export default {
		name: 'jobHunting',
		components: {
			Header
		},
		metaInfo: {
			title: '找工作'
		},
		data() {
			return {
				search: '',
				positionEnumerationList:[],
				welfareList: [],
				checkedWelfare: [],
				salaryList: [],
				salaryListOn: 0,
				positionListOn:0,
				currentPage: 1,
				SizeChange: 10,
				TotalNumber: 100,
				//热门城市
				hotCity: [{
						cityCode: 110101,
						cityName: '长沙市'
					},
					{
						cityCode: 110102,
						cityName: '岳阳市'
					},
					{
						cityCode: 110103,
						cityName: '株洲市'
					},
					{
						cityCode: 110104,
						cityName: '湘潭市'
					},
					{
						cityCode: 110105,
						cityName: '衡阳市'
					},
					{
						cityCode: 110106,
						cityName: '邵阳市'
					},
					{
						cityCode: 110107,
						cityName: '常德市'
					},
					{
						cityCode: 110108,
						cityName: '益阳市'
					},

					{
						cityCode: 110109,
						cityName: '郴州市'
					},
					{
						cityCode: 110110,
						cityName: '永州市'
					},
					{
						cityCode: 110111,
						cityName: '张家界市'
					},
					{
						cityName: '怀化市',
						cityCode: 110118
					},
					{
						cityName: '娄底市',
						cityCode: 110119
					},
					{
						cityName: '湘西州',
						cityCode: 110120
					}
				],
				region: [],
				CityOn: {
					City1: 0,
					City2: {
						i: 0,
						j: 0
					},
					CityType: true,
					result: ''
				},
				selectCity: false,
				sortType: 'COMMISSSION',
				positionList: [],
				educationList: [],
				workingYearList: [],
				loading: false,
				centerDialogVisible: false,
				qrCode: '',
				inviteCode: '',
				qrCodeLoading: false,
				positionOn: 0
			}
		},
		async mounted() {
			if (this.$route.query.city) {
				this.CityOn.result = this.$route.query.city
			} else {
				this.CityOn.result = this.hotCity[0].cityName;
			}
			this.region = area;
			this.welfareList = await this.getTable('WELFAREENUM');
			this.salaryList = await this.getTable('SALARYRANGEENUM');
			this.positionEnumerationList = await this.getTable('JOBTYPEENUM');
			this.educationList = await this.getTable('INTERVIEWEDUCATIONTYPEENUM');
			this.workingYearList = await this.getTable('INTERVIEWWORKPERIODENUM');
			this.inviteCode = await this.getInviteCode()
			this.getList();
			console.log(this.salaryList);
		},
		methods: {
			/**
			 * 获取二维码
			 */
			makeQrcode(id) {
				this.qrCodeLoading = true;
				let params = {
					scene: id + '&' + this.inviteCode + '&OFFICIAL_WEBSITE',
					page: "packageHome/pages/home/job/detail"
				}
				this.http.get('/wx/ma/qrcode', params).then(res => {
					console.log(res.data);
					this.qrCode = 'data:image/png;base64,' + res.data;
					setTimeout(() => {
						this.qrCodeLoading = false;
					}, 500)
				}).catch(err => console.log(err))
			},
			getInviteCode() {
				let params = {
					codeEnum: 'REGISTER_USER'
				}
				return new Promise((resolve) => {
					this.http.get('/officialWebsite/getOfficialWebsiteInviteCode', params).then(res => {
						resolve(res.data.data)
					})
				})
			},
			request(){
				this.currentPage=1;
				this.getList();
			},
			/**
			 * 申请面试
			 */
			interview(id, i) {
				console.log(i);
				this.positionOn = i;
				this.centerDialogVisible = true;
				this.makeQrcode(id);
			},
			/**
			 * 职位筛选
			 */
			positionClick(i){
				this.positionListOn = i;
				this.request();
			},
			/**
			 * 福利筛选
			 */
			checkbox(){
				this.request();
			},
			/**
			 *	工资筛选
			 */
			salaryClick(i) {
				this.salaryListOn = i;
				this.request();
			},
			/**
			 * 城市筛选
			 */
			hotCityClick(type, i, j) {
				this.$router.push({
					query: {}
				});
				this.CityOn.CityType = type;
				if (type) {
					this.CityOn.City1 = i;
					this.CityOn.result = this.hotCity[i].cityName;
				} else {
					this.CityOn.City2.i = i;
					this.CityOn.City2.j = j;
					this.CityOn.result = this.region[i].cityList[j];
				}
				this.request();
			},
			/**
			 * 获取筛选列表
			 */
			getTable(type) {
				let params = {
					tableDataEnum: type
				}
				return new Promise((resolve) => {
					this.http.get('/getTableDataByParam', params).then(res => {
						resolve(res.data.data)
					})
				})
			},
			/**
			 * 根据筛选条件获取列表
			 */
			getList() {
				let param = new URLSearchParams();
				param.append('pageNum', this.currentPage)
				param.append('pageSize', this.SizeChange)
				param.append('sortType', this.sortType)
				param.append('address.city', this.CityOn.result)
				param.append('name', this.search)
				param.append('categoryName', this.positionEnumerationList[this.positionListOn].label=='不限'?'':this.positionEnumerationList[this.positionListOn].label)
				param.append('salarys', this.salaryList[this.salaryListOn].value)
				param.append('startSalary', this.salaryList[this.salaryListOn].startSalary)
				param.append('endSalary', this.salaryList[this.salaryListOn].endSalary)
				this.checkedWelfare.forEach(ele => {
					param.append('welfares', ele)
				})
				this.loading = true;
				this.http.get('/officialWebsite/filter/list', param).then(res => {
					console.log(res.data.data);
					this.positionList = res.data.data;
					this.TotalNumber = res.data.totalRecords;
					this.selectCity = false;
					setTimeout(() => {
						this.loading = false;
					}, 500)
				}).catch(err => console.log(err))
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.SizeChange = val;
				this.getList();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.currentPage = val;
				this.getList();
			},
			toPage(url) {
				this.$router.push(url)
			},
			toPageTwo(id) {
				this.$router.push({
					path: './JobDetails',
					query: {
						id
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.Mask{
		width: 100%;
		height: 100vh;
		position:fixed;
		top: 0;
		left: 0;
	}

	.reweima {
		.right {
			img {
				width: 180px;
				height: 180px;
				margin-bottom: 19px;
			}

			text-align: center;
			font-size: 14px;
			color: #666;
			margin-left: 28px;
		}

		.left {
			.address {
				font-size: 14px;
				color: #666666;

				img {
					width: 10px;
					height: 12px;
					margin-right: 3px;
				}

				display: flex;
				align-items: center;
				margin-top: 3px;
			}

			.Company {
				margin-top: 22px;
				font-size: 16px;
				color: #333;
			}

			.welfare {
				display: flex;
				flex-wrap: wrap;
				margin-bottom: 20px;
				border-bottom: 1px dashed #DDDDDD;
				padding-bottom: 25px;

				div {
					padding: 4px 12px;
					background-color: #E5FCFF;
					color: #00BCD4;
					font-size: 14px;
					border-radius: 4px;
					margin: 0 12px 12px 0;
				}
			}

			.money {
				font-size: 24px;
				color: #FF4A32;
				margin-bottom: 20px;
			}

			.title {
				color: #333333;
				font-size: 20px;
				display: flex;
				align-items: center;
				margin-bottom: 15px;
			}

			width: 292px;
			margin-top: 17px;
		}

		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	/deep/.el-dialog {
		border-radius: 6px !important;
	}

	/deep/.el-dialog__header {
		border-bottom: 1px solid #DDDDDD;
	}

	.NotYet {
		width: 346px;
		text-align: center;
		font-size: 16px;
		color: #666666;
		margin: 143px auto;

		img {
			width: 346px;
			height: 278px;
			margin-bottom: 28px;
		}
	}
	
	.citys {
		.moduo {
			padding: 20px;
			text-align: right;
			font-size: 14px;
			color: #00BCD4;
			cursor: pointer;
		}

		.regionList {
			.regionList-q {
				.list {
					.on {
						color: #00bcd4 !important;
					}

					div:hover {
						color: #00bcd4 !important;
					}

					div {
						font-size: 14px;
						color: #666666;
						margin-right: 29px;
						margin-bottom: 20px;
						cursor: pointer;
					}

					display: flex;
					flex-wrap: wrap;
				}

				.regionName {
					font-size: 14px;
					color: #333333;
					flex-shrink: 0;
					margin-right: 18px;
					margin-top: -14px;
				}

				padding: 15px 0 0;
			}

			padding: 0 19px;
			border-bottom: 1px solid #DDDDDD;
		}

		.hotCity {
			.list {
				.on {
					color: #00bcd4 !important;
					border: 1px solid #00bcd4 !important;
				}

				div:hover {
					color: #00bcd4 !important;
					border: 1px solid #00bcd4 !important;
				}

				div {
					width: 70px;
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 14px;
					color: #666666;
					border: 1px solid #DDDDDD;
					border-radius: 4px;
					margin: 0 14px 14px 0;
					cursor: pointer;
				}

				display: flex;
				flex-wrap: wrap;
				margin-top: 20px;
			}

			.title {
				font-size: 16px;
				color: #333333;
			}

			padding: 20px 20px 6px 20px;
			border-bottom: 1px solid #DDDDDD;
		}

		width: 470px;
		position: absolute;
		top:132px;
		left: 352px;
		background-color: #FFFFFF;
		border: 1px solid #DDDDDD;
		z-index: 500;
	}

	.position-list {
		overflow: hidden;
		.list:hover{
			.right .title .name{
				color: #00bcd4;
			}
		}
		.list {
			.right {
				.reward {
					.reward-anniu:hover {
						background-color: #00bcd48a;
					}

					.reward-anniu {
						width: 120px;
						height: 40px;
						text-align: center;
						line-height: 40px;
						font-size: 16px;
						color: #FFFFFF;
						border-radius: 4px;
						background-color: #00BCD4;
						cursor: pointer;
					}

					.reward-list {
						.reward-three {
							border: 1px solid #089DFE;
							color: #089DFE;
						}

						.reward-two {
							border: 1px solid #FB7E1E;
							color: #FB7E1E;
						}

						.reward-one {
							border: 1px solid #FD4459;
							color: #FD4459;
						}

						div {
							font-size: 14px;
							padding: 7px 12px;
							border-radius: 4px;
							margin-right: 15px;
						}
					}
				}

				.nanse {
					span {
						color: #00BCD4;
					}
				}

				.treatment {
					span {
						padding-right: 12px;
					}

					font-size: 14px;
					color: #666666;
					margin-bottom: 9px;
				}

				.title {
					.money {
						color: #FF4A32;
						font-weight: bold;
					}
					.name {
						color: #333333;
						font-weight: bold;

						img {
							width: 23px;
							height: 23px;
							margin-left: 15px;
							margin-top: -5px;
						}
					}

					font-size:18px;
					margin-bottom: 12px;
				}

				margin-left: 20px;
				width: 1019px;
			}

			.logo {
				img {
					height: 100%;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
				}

				width: 159px;
				height: 159px;
				overflow: hidden;
				border: 1px solid #DDDDDD;
				position: relative;
				border-radius: 6px;
				box-sizing: border-box;
			}

			width: 100%;
			padding: 40px 0;
			border-bottom: 1px solid #F4F4F4;
			display: flex;
			cursor: pointer;
		}

		width: 100%;
		background-color: #FFFFFF;
		padding-bottom: 60px;
	}

	/deep/.is-checked .el-checkbox__inner {
		background-color: #00BCD4;
		border-color: #00BCD4;
	}

	/deep/.is-checked .el-checkbox__label {
		color: #00BCD4;
	}

	.screen {
		.screen-list {
			.WelfareNo {
				padding: 4px 10px;
				border-radius: 4px;
				border: 1px solid #DDDDDD;

			}

			.list-on {
				background-color: #00BCD4;
				color: #FFFFFF !important;
				padding: 4px 10px;
				border-radius: 4px;
				border: none;
			}

			.list-div {
				div {
					margin: 0 19px 19px 0;
					flex-shrink: 0;
					cursor: pointer;
				}

				margin-left: 28px;
				flex-wrap: wrap;
				display: flex;
				align-items: center;
			}

			.name {
				flex-shrink: 0;
				margin-top: 4px;
			}

			font-size: 14px;
			display: flex;
			color: #666666;
			margin-bottom: 20px;
		}

		width: 100%;
		background-color: #FFFFFF;
		padding: 30px 0 0;
	}

	/deep/.searchDiv .el-input__inner {
		border: 1px solid #ffffff;
		font-size: 14px;
	}

	.searchDiv {
		.searchTo {
			.searchButton:hover {
				color: #FFFFFF;
			}

			.searchButton {
				width: 150px;
				height: 54px;
				background-color: #00BCD4;
				color: #d4eff3;
				font-size: 16px;
				font-weight: bold;
				text-align: center;
				line-height: 54px;
				border-radius: 0px 6px 6px 0px;
			}

			.address {
				img {
					width: 10px;
					height: 7px;
					margin-left: 14px;
				}

				height: 20px;
				width: 150px;
				font-size: 14px;
				color: #666666;
				display: flex;
				align-items: center;
				justify-content: center;
				border-right: 1px solid #DDDDDD;
			}

			margin-top: 32px;
			width: 1000px;
			height: 54px;
			border: 1px solid #DDDDDD;
			box-sizing: border-box;
			border-radius: 6px;
			background-color: #FFFFFF;
			cursor: pointer;
		}

		/deep/.el-breadcrumb__item .is-link {
			font-weight: 400 !important;
		}

		/deep/.el-breadcrumb__inner:hover {
			color: #00BCD4;
		}

		/deep/.el-breadcrumb__inner {
			color: #999999;
		}

		.position {
			font-size: 14px;
			color: #999999;
			display: flex;
			align-items: center;
		}

		position: relative;
		width: 100%;
		background-color: #FBFBFB;
		padding: 30px 0;
	}

	.content {
		width: 1200px;
		margin: auto;
	}
</style>
